import { LOGIN_SUCCESS, LOGIN_FAILED, LOGOUT } from './constants';
import { AuthService } from '../../../Components/services';
import { JWT } from '../../../Components/shared';

export const login = (data) => async (dispatch) => {
  try {
    const response = await AuthService.Login(data);
    if (response.success) {
      dispatch({ type: LOGIN_SUCCESS, payload: response.access_token });
      JWT.setJwt(response.access_token);
      return response;
    } else {
      dispatch({ type: LOGIN_FAILED, payload: null });
      return response;
    }
  } catch (error) {
    dispatch({ type: LOGIN_FAILED, payload: null });
    return Promise.reject(error);
  }
};

export const logout = () => (dispatch) => {
    JWT.removeJWT();
    dispatch({ type: LOGOUT });
};